import type { DocumentContext } from '../domain/DocumentContext';
import { resolveTokensForHtml, type ResolveTokensOptions } from './resolveTokens';
import { splitProseBodyHtml } from './splitProseBodyHtml';

/**
 * A prose body's top-level HTML segments, tokens resolved with HTML-escaped values. `ProseRender`
 * slices and renders these, and `DocumentRender` hands their count to pagination — one function, so
 * the two can never disagree about where a body splits.
 */
export function resolveProseSegments(
  bodyHtml: string,
  context: DocumentContext,
  options?: Pick<ResolveTokensOptions, 'knownPaths' | 'keepTokens'>
): string[] {
  return splitProseBodyHtml(resolveTokensForHtml(bodyHtml, context, options));
}
